<template>
  <div class="turnstile-root">
    <div ref="container"></div>
    <p v-if="missingKey" class="turnstile-error">
      La vérification de sécurité n'est pas configurée. Connexion impossible.
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const emit = defineEmits<{
  (e: 'verified', token: string): void
  (e: 'expired'): void
  (e: 'error'): void
}>()

const container = ref<HTMLElement | null>(null)
const missingKey = ref(false)
let widgetId: string | null = null
let waitInterval: ReturnType<typeof setInterval> | null = null

const renderWidget = () => {
  const sitekey = import.meta.env.VITE_TURNSTILE_SITE_KEY
  if (!sitekey) {
    missingKey.value = true
    emit('error')
    return
  }
  if (!window.turnstile || !container.value) return

  widgetId = window.turnstile.render(container.value, {
    sitekey,
    theme: 'dark',
    callback: (token: string) => {
      emit('verified', token)
    },
    'expired-callback': () => {
      emit('expired')
    },
    'error-callback': () => {
      emit('error')
    },
  })
}

onMounted(() => {
  const sitekey = import.meta.env.VITE_TURNSTILE_SITE_KEY
  if (!sitekey) {
    missingKey.value = true
    emit('error')
    return
  }

  if (window.turnstile) {
    renderWidget()
  } else {
    waitInterval = setInterval(() => {
      if (window.turnstile) {
        if (waitInterval) {
          clearInterval(waitInterval)
          waitInterval = null
        }
        renderWidget()
      }
    }, 100)
  }
})

onUnmounted(() => {
  if (waitInterval) {
    clearInterval(waitInterval)
    waitInterval = null
  }
  if (widgetId && window.turnstile) {
    window.turnstile.remove(widgetId)
  }
})
</script>

<style scoped>
.turnstile-error {
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}
</style>
